import { Link } from "react-router-dom";

const columns: { title: string; links: { to: string; label: string }[] }[] = [
  {
    title: "Company",
    links: [
      { to: "/services", label: "Our Services" },
      { to: "/growth-strategy", label: "Growth Strategy" },
      { to: "/meet-us", label: "Meet Us" },
      { to: "/contact", label: "Get in Touch" },
    ],
  },
  {
    title: "Insights",
    links: [
      { to: "/resources", label: "Resources" },
      { to: "/growth-strategy#industry-applications", label: "Case Studies" },
      { to: "/aeo-to-agentic-commerce", label: "AEO to Agentic Commerce" },
      { to: "/your-growth-canvas", label: "Agent Audit" },
    ],
  },
  {
    title: "Answers",
    links: [
      { to: "/what-is-agentic-commerce", label: "What is agentic commerce?" },
      { to: "/agentic-commerce-protocol", label: "Agentic commerce protocols" },
      { to: "/agentic-commerce-risks", label: "Risks & governance" },
      { to: "/agentic-commerce-optimization-companies", label: "Optimization companies" },
    ],
  },
];

const Footer = () => {
  return (
    <footer className="border-t border-border py-12">
      <div className="section-container">
        <div className="grid gap-10 md:grid-cols-[1.2fr_repeat(3,1fr)]">
          <div>
            <Link to="/" className="flex items-center gap-2">
              <img src="/logo_growagentic.svg" alt="GrowAgentic logo" className="h-6 w-6" />
              <span className="font-mono text-sm font-bold tracking-wider text-foreground">GrowAgentic</span>
            </Link>
            <p className="mt-3 max-w-xs text-xs leading-relaxed text-muted-foreground">
              Making businesses discoverable, decidable and transactable for AI agents.
            </p>
          </div>

          {columns.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h2 className="font-mono text-[0.65rem] uppercase tracking-wider text-foreground">{col.title}</h2>
              <ul className="mt-3 space-y-2">
                {col.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-xs text-muted-foreground transition-colors hover:text-foreground"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <p className="mt-10 border-t border-border pt-6 text-xs text-muted-foreground">
          © {new Date().getFullYear()} GrowAgentic. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
